import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Cases from './Cases';

function DefaultBoard() {
  const [cases, setCases] = useState([]);
  

  useEffect(() => {
    getCases();
  }, []);

  const getCases = async () => {
    const token = localStorage.getItem("token");
    try {
      const email = localStorage.getItem('clientEmail');
      if (!email) {
        console.warn("No email found in localStorage.");
        return;
      }
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/Projects/by-contact-email?email=${email}`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      setCases(res.data);
    } catch (err) {
      console.error("Error fetching filtered cases:", err);
    }
  };
  
  

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6 text-white">Dashboard</h1>

      <Cases cases={cases} />
    </div>
  );
}

export default DefaultBoard;
